import { HeadingLevels, StandardHeading, StandardLabel, StandardText } from '@brandfolder/react';
import { BFMultiSelect, BFMultiSelectOption , BFStandardCheckbox } from '@integration-frontends/common/ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export const LocaleConfigurationSection = () => {
  const { setValue, watch, register } = useFormContext();

  register('locale_codes');
  register('should_replace_asset_name');

  const selectedLocales = watch('locale_codes') || [];
  const shouldReplaceAssetName = watch('should_replace_asset_name') || false;

  // EN is default and always included, so not in the list
  const localeOptions: BFMultiSelectOption[] = [
    { value: 'cs', label: 'Czech' },
    { value: 'de', label: 'German' },
    { value: 'es', label: 'Spanish' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr', label: 'French' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'it', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'ko', label: 'Korean' },
    { value: 'nl', label: 'Dutch' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese (Portugal)' },
    { value: 'ro', label: 'Romanian' },
    { value: 'ru', label: 'Russian' },
    { value: 'sv', label: 'Swedish' },
    { value: 'th', label: 'Thai' },
    { value: 'tr', label: 'Turkish' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'zh', label: 'Chinese' },
  ];

  const handleLocaleChange = (values) => {
    setValue('locale_codes', values || [], { shouldDirty: true });
  };

  const handleShouldReplaceAssetNameChange = (event) => {
    setValue('should_replace_asset_name', event.target.checked, { shouldDirty: true });
  };

  return (
    <section
      className="destination-section workflow-info-section"
      data-testid="locale-configuration-section"
    >
      <StandardHeading level={HeadingLevels.h2} className="workflow-info-section-header">
        Locale Configuration
      </StandardHeading>
      <section className="workflow-info-section-body">
        <div className="workflow-info-section-content">
          <div className="workflow-field workflow-field-margin">
            <StandardLabel
              data-testid="locale-configuration-label"
              htmlFor="select-locales"
              className="mb-xxs"
            >
              Brandfolder Locales {selectedLocales?.length > 0 && `(${selectedLocales.length} selected)`}
            </StandardLabel>
            <BFMultiSelect
              id="select-locales"
              data-testid="locale-configuration-select"
              placeholder="Select Locales"
              options={localeOptions}
              selected={localeOptions.filter((locale) => selectedLocales?.includes(locale.value))}
              selectedValues={selectedLocales}
              onChange={handleLocaleChange}
              panelStyleOptions={{ width: '100%' }}
              buttonStyleOptions={{ width: '100%' }}
              getOptionKey={(option) => option.value}
            />
            <StandardText className="workflow-field-sublabel">
              Select the Brandfolder locales to sync from Getty Images.
            </StandardText>
          </div>
          <div className="workflow-field">
            <BFStandardCheckbox
              data-testid="getty-should-replace-asset-name-checkbox"
              id="getty-should-replace-asset-name-checkbox"
              style={{ height: '16px', marginRight: '12px' }}
              checked={shouldReplaceAssetName}
              onChange={handleShouldReplaceAssetNameChange}
              label={'Use localized asset names'}
              labelClassName="getty-checkbox-label"
            />
            <StandardText className="workflow-field-sublabel">
              If selected, asset names will be replaced with the localized titles from Getty Images.
            </StandardText>
          </div>
        </div>
      </section>
    </section>
  );
};
